<script lang="ts">
	import { Icon, Button, ButtonSize, ButtonType } from '@repo/commons/components'

	interface Props {
		message?: string
		retry?: () => void
	}

	let { message = 'Something went wrong while loading the application.', retry }: Props = $props()
</script>

<div class="flex flex-col items-center justify-center h-screen px-6 py-10 text-center bg-gray-50">
	<div class="bg-white shadow-xl rounded-xl p-8 max-w-md w-full">
		<div class="mx-auto mb-4 h-16 w-16 rounded-full bg-red-100 flex items-center justify-center">
			<Icon name="close" class="text-red-500" />
		</div>

		<h2 class="text-2xl font-semibold text-gray-800 mb-2">Something went wrong</h2>

		<p class="text-gray-600 mb-6">
			{message}
		</p>

		{#if retry}
			<div class="flex items-center justify-center">
				<Button
					buttonText="Try Again"
					buttonSize={ButtonSize.LARGE}
					buttonType={ButtonType.INVERSE_OUTLINE}
					onclick={retry}
				/>
			</div>
		{/if}
	</div>
</div>
